import { styled, Tooltip, tooltipClasses } from '@mui/material';
import React, { useEffect } from 'react';
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import { Button } from '../../../../Components/StyledComponents';
import './Holiday.scss';
import { cloneDeep } from 'lodash-es';

const holidayText = `포함일

1. 국경일 중 3·1절, 광복절, 개천절 및 한글날\n
2. 1월 1일
3. 설날 전날, 설날, 설날 다음날 (음력 12월 말일, 1월 1일, 2일)
4. 석가탄신일 (음력 4월 8일)
5. 어린이날 (5월 5일)
6. 현충일 (6월 6일)
7. 추석 전날, 추석, 추석 다음날(음력 8월 14일, 15일, 16일)
8. 성탄절 (12월 25일)
9. ｢공직선거법｣ 제34조에 따른 임기 만료에 의한 선거의 선거일
10. 기타 정부에서 수시 지정하는 날`

const RegularCycle = [
    '매주',
    '매월 첫번째',
    '매월 두번째',
    '매월 세번째',
    '매월 네번째',
    '매월 다섯번째',
    '매월 마지막주'
]
const RegularDay = [
    '월요일',
    '화요일',
    '수요일',
    '목요일',
    '금요일',
    '토요일',
    '일요일'
]

const Holiday = ({ info, patchDayoffs }) => {
    const [holiday, setHoliday] = React.useState(false)
    const [regularHoliday, setRegularHoliday] = React.useState([])

    useEffect(() => {
        if (typeof info !== 'undefined') {
            setHoliday(cloneDeep(info.Holiday))
            setRegularHoliday(cloneDeep(info.RegularHolidays))
        }
    }, [])

    const handleRegularInterval = (val, i) => {
        let arr = regularHoliday;

        arr[i].Interval = val;

        setRegularHoliday([...arr])
    }

    const handleRegularDay = (val, i) => {
        let arr = regularHoliday;

        arr[i].Day = val;

        setRegularHoliday([...arr])
    }

    const removeRegular = (index) => {
        let arr = regularHoliday;

        arr.splice(index, 1)
        setRegularHoliday([...arr])
    }

    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#fff',
            color: '#9f9f9f',
            maxWidth: 342,
            fontSize: 12,
            boxShadow: '0 12px 14px 0 rgba(0, 0, 0, 0.03)'
        },
    }));

    const patch = () => {
        patchDayoffs({
            Holiday: holiday,
            RegularHolidays: regularHoliday
        })
    }

    return (
        <div className='holiday-modal'>
            <HtmlTooltip placement='bottom-start'
                title={
                    <React.Fragment>
                        <div>
                            <br />포함일<br /><br />
                            <br />
                            1. 국경일 중 3·1절, 광복절, 개천절 및 한글날<br />
                            2. 1월 1일<br />
                            3. 설날 전날, 설날, 설날 다음날 (음력 12월 말일, 1월 1일, 2일)<br />
                            4. 석가탄신일 (음력 4월 8일)<br />
                            5. 어린이날 (5월 5일)<br />
                            6. 현충일 (6월 6일)<br />
                            7. 추석 전날, 추석, 추석 다음날(음력 8월 14일, 15일, 16일)<br />
                            8. 성탄절 (12월 25일)<br />
                            9. ｢공직선거법｣ 제34조에 따른 임기 만료에 의한 선거의 선거일<br />
                            10. 기타 정부에서 수시 지정하는 날<br /><br />
                        </div>
                    </React.Fragment>
                }
            >
                <div className='row'>
                    <p className='modal-title'>공휴일 휴무 안내</p>
                    <img src={require('../../../../aseets/icons/tooltip.svg').default} style={{ width: 24, height: 24, marginLeft: 8, marginBottom: 16 }} />
                </div>
            </HtmlTooltip>
            <div className='row'>
                <button className={`${holiday ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight: 32, width: 153 }} onClick={() => setHoliday(true)}>
                    <div className='row' style={{ justifyContent: 'center' }}>
                        {
                            holiday ?
                                <img src={require('../../../../aseets/icons/check.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                                :
                                <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                        }
                        공휴일은 쉬어요
                    </div>
                </button>

                <button className={`${!holiday ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setHoliday(false)} style={{ width: 165 }}>
                    <div className='row' style={{ justifyContent: 'center' }}>
                        {
                            holiday ?
                                <img src={require('../../../../aseets/icons/close.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                                :
                                <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                        }
                        공휴일도 영업해요
                    </div>
                </button>
            </div>

            <div style={{ marginTop: 40 }}>
                <p className='modal-title' style={{ marginBottom: 16 }}>정기 휴일</p>
                {
                    regularHoliday.map((data, i) => {
                        return (
                            <div key={i}>
                                {
                                    i > 0 ?
                                        <div className='divider' />
                                        : null
                                }
                                <div className='row'>
                                    <Dropdown
                                        id='regular-interval'
                                        options={[
                                            { key: '매주', value: 0 },
                                            { key: '매월 첫번째', value: 1 },
                                            { key: '매월 두번째', value: 2 },
                                            { key: '매월 세번째', value: 3 },
                                            { key: '매월 네번째', value: 4 },
                                            { key: '매월 다섯번째', value: 5 },
                                            { key: '매월 마지막', value: 255 }
                                        ]}
                                        onItemClick={(val) => handleRegularInterval(val, i)}
                                        width={137}
                                        btnStyle={{ marginRight: 16 }}
                                        value={regularHoliday[i].Interval === 255 ? '매월 마지막' : RegularCycle[regularHoliday[i].Interval]}
                                    />
                                    <Dropdown
                                        id='regular-day'
                                        options={[
                                            { key: '월요일', value: 0 },
                                            { key: '화요일', value: 1 },
                                            { key: '수요일', value: 2 },
                                            { key: '목요일', value: 3 },
                                            { key: '금요일', value: 4 },
                                            { key: '토요일', value: 5 },
                                            { key: '일요일', value: 6 }
                                        ]}
                                        onItemClick={(val) => handleRegularDay(val, i)}
                                        width={137}
                                        btnStyle={{ marginRight: 24 }}
                                        value={RegularDay[regularHoliday[i].Day]}
                                    />

                                    <Button variant="sub" onClick={() => removeRegular(i)} style={{ width: 28, height: 28, borderRadius: 100, boxSizing: 'border-box', padding: 0 }}>
                                        <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width: 24, height: 24, marginTop: 2 }} />
                                    </Button>
                                </div>
                            </div>
                        )
                    })
                }

                <Button variant="sub" style={{ marginTop: 16, paddingLeft: 16, paddingRight: 16 }} onClick={() => setRegularHoliday(old => [...old, { Interval: 0, Day: 0 }])} small>
                    <div className='row'>
                        <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                        추가하기
                    </div>
                </Button>
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default Holiday;